module.exports = __webpack_public_path__ + "static/example-from-our-blog-9e5ca46a347631442f61a81fd54019dd.png";